export const translations = {
    en: {
        language: {
            label: "Language",
            options: {
                en: "English",
                it: "Italiano",
                de: "Deutsch"
            }
        },
        nav: {
            home: "Home",
            about: "About",
            services: "Services",
            references: "References",
            contacts: "Contacts",
            projects: "Projects",
            works: "Works"
        },
        footer: {
            cv: "Curriculum vitae"
        },
        reviews: {
            translationLabel: "Italiano",
            originalLabel: "Original"
        },
        home: {
            meta: {
                title: "Maurizio Brioschi: Team leader, Software architect, Software engineer web and Digital transformation expert freelance",
                description: "Empower your digital journey with a versatile freelance team led by experts in software architecture, engineering, and digital transformation. From strategic guidance to hands-on implementation, I lead the way in navigating the complexities of modern web development. Discover how we can elevate your projects to new heights.",
                keywords: "freelancer, team lead, software architect, software engineer, web development, digital transformation"
            },
            carousel: [
                {
                    title: "Team leader",
                    description: "Experienced and dedicated team leader adept at fostering collaboration, driving results, and empowering team members to excel. Skilled in strategic planning, problem-solving, and fostering a positive team culture to achieve organizational goals."
                },
                {
                    title: "Software architect",
                    description: "Dynamic software architect with a proven track record of designing and implementing robust, scalable software solutions. Proficient in translating complex business requirements into innovative architectural designs, driving technical excellence, and ensuring alignment with industry best practices."
                },
                {
                    title: "Software engineer web",
                    description: "Passionate software engineer with a strong foundation in coding, testing, and debugging software applications. Experienced in collaborating with cross-functional international teams to deliver high-quality solutions while continuously learning and adapting to new technologies."
                }
            ],
            offer: {
                label: "Summer 2026",
                title: "Seasonal landing pages for local businesses in Sardinia",
                description: "A clear and mobile‑friendly landing page to get bookings and contacts during the summer season.",
                cta: "View the offer"
            },
            storiesTitle: "Stories about me",
            readAll: "Read all"
        },
        about: {
            meta: {
                title: "Maurizio Brioschi about: all important steps in my career to become a team leader, software architect and software engineer",
                description: "All the steps of Maurizio Brioschi career on the path to become a team leader, software architect and engineer. Download my CV to discover all companies, studies and jobs done.",
                keywords: "freelancer, cv, curriculum vitae, career, jobs, companies, studies, education, family"
            },
            title: "About my career",
            certifications: {
                linkLabel: "Certification link"
            },
            timeline: {
                t2023_present: "February 2023 - Present",
                t2022_oct_2023_nov: "October 2022 - November 2023",
                t2022_feb_2023_jan: "February 2022 - January 2023",
                t2022_oct: "October 2022",
                t2020_jun: "June 2020",
                t2020_aug: "August 2020",
                t2019_jul_2022_jan: "July 2019 - January 2022",
                t2019_apr_2019_jul: "April 2019 - July 2019",
                t2018_nov_2019_mar: "November 2018 - March 2019",
                t2018_feb: "February 2018",
                t2017_apr_2018_may: "April 2017 - May 2018",
                t2015_oct_2017_mar: "October 2015 - March 2017",
                t2015_sep: "September 2015",
                t2015_may_2015_sep: "May 2015 - September 2015",
                t2015_apr: "April 2015",
                t2014_nov_2015_apr: "November 2014 - April 2015",
                t2015_feb: "February 2015",
                t2014_sep: "September 2014",
                t2014_may_2014_nov: "May 2014 - November 2014",
                t2015_oct_2017_mar_dup: "October 2015 - March 2017",
                t2012_may_2013_jan: "May 2012 - January 2013",
                t2007_feb_2013_feb: "February 2007 - February 2013",
                t2006_may: "May 2006",
                t2006_sep_2011_mar: "September 2006 - March 2011",
                t2006_apr: "April 2006",
                t2002_feb_2012_dec: "February 2002 - December 2012",
                t2005_apr_2005_oct: "April 2005 - October 2005",
                t2000_2002: "2000 - 2002",
                t2000_jun: "June 2000"
            },
            roles: {
                solutionArchitect: "Software/Solution Architect and Technical Lead",
                cto: "Chief Technology Officer",
                seniorEngineer: "Senior software engineer",
                sonBorn: "My son Manuel born",
                adobeCert: "Adobe Certified Expert-Adobe Commerce Cloud Developer",
                movedSardinia: "Moved to Sardinia",
                techLeader: "Technical Leader - Senior Engineer",
                seniorBackend: "Senior Backend Engineer",
                seniorSoftwareEngineer: "Senior Software Engineer",
                gkeCert: "Getting Started with Google Kubernetes Engine",
                limangoSenior: "Senior Software Engineer",
                mothershipSenior: "Senior Developer",
                movedMunich: "Moved to München",
                shopwingsSenior: "Senior Developer",
                movedBerlin: "Moved to Berlin",
                itLeadDeveloper: "IT Lead Developer",
                gotMarried: "Got married",
                daughterBorn: "My daughter Mia born",
                dserviceSenior: "Senior Developer",
                contactlabDev: "Software Developer",
                seniorWebDev: "Senior Web developer",
                ownerCto: "Owner and CTO",
                sapConsultant: "Development Consultant SAP SDK",
                analystProgrammer: "Analyst and Programmer involved also in Database for 2.0 web application",
                bachelor: "Bachelor's degree in Informatics",
                analystDeveloper: "Analyst, Programmer and Software Developer",
                programmer: "Programmer",
                systemist: "Systemist",
                gymnasium: "Scientific Gymnasium degree"
            },
            items: {
                mazzmedia: {
                    location: "Milan - Italy",
                    list: {
                        l1: "Technical leader: managing 4 developers and customer requirements",
                        l2: "Software and infrastructure architect on cloud (AWS) using AWS ECS architecture",
                        l3: "Docker development environment maintainer",
                        l4: "Pipeline creation for continuous delivery",
                        l5: "Responsible for projects workflow and Agile",
                        l6: "Responsible for code quality via code reviews, testing, logging and performance monitoring",
                        l7: "Development (Laravel, Reactjs, Vuejs, Wordpress, Prestashop, Magento)",
                        l8: "Website optimisations"
                    }
                },
                palco: {
                    location: "London - UK",
                    list: {
                        l1: "SaaS maintainer on cloud (Linode - AWS)",
                        l2: "Tech leader and developer (Laravel - Reactjs)"
                    }
                },
                newporttakkt: {
                    location: "Stuttgart - DE",
                    list: {
                        l1: "Software architecture",
                        l2: "Shopware development",
                        l3: "Software optimisations",
                        l4: "Code reviews"
                    }
                },
                mediawave: {
                    location: "München - DE",
                    list: {
                        l1: "Technical/team leader: managing 4 developers and customer requirements",
                        l2: "Part of the recruitment process, performing interviews for right candidates",
                        l3: "Responsible for code quality via code reviews, testing, logging and performance monitoring",
                        l4: "Magento cloud maintainer",
                        l5: "Docker development environment maintainer",
                        l6: "Software architecture of Magento 2 projects involving: RabbitMq, RestApi, CRM integrations, GraphQL development, Elasticsearch",
                        l7: "Pipeline creation for continuous delivery in GitLab",
                        l8: "Magento2 development",
                        l9: "Product configurator development and architecture in Vue.js completely integrated in Dynamics365",
                        l10: "React development for PWA Studio project"
                    }
                },
                vitafy: {
                    location: "München - DE",
                    list: {
                        l1: "Magento 1 developer",
                        l2: "Node.js developer",
                        l3: "DevOps tasks related to Docker and GitLab CI optimizations"
                    }
                },
                burda: {
                    location: "München - DE",
                    list: {
                        l1: "DevOps: new development environment with Docker and Docker images maintainer",
                        l2: "Drupal developer"
                    }
                },
                limango: {
                    location: "München - DE",
                    list: {
                        l1: "Senior backend developer: Laravel, MySql, Javascript, RabbitMq, Elasticsearch",
                        l2: "Supplier order micro service",
                        l3: "Responsibility for code quality: tests, code style, documentation",
                        l4: "In API core member group"
                    }
                },
                mothership: {
                    location: "München - DE",
                    list: {
                        l1: "Backend developer: website optimizations through the creation of new extensions and modules",
                        l2: "Magento developer",
                        l3: "Exxpozed shop refactory: main responsibilities are the complete data import and synchronization module from a PIM System into Magento Database; development of a module to manage Magento database into Elasticsearch; library to schedule jobs inside Rabbitmq; Emarsys integration into the system for marketing; PHP7 fixes.",
                        l4: "Company core libraries development and maintainer",
                        l5: "Code reviews"
                    },
                    linkLabel: "Exxpozed shop refactory",
                    githubLabel: "https://github.com/mothership-gmbh"
                },
                shopwings: {
                    location: "Berlin - DE",
                    list: {
                        l1: "Vagrant and Puppet administrator",
                        l2: "Symfony2 development for the web application and for API",
                        l3: "TDD for API – PHPUnit - Raml",
                        l4: "Senior PHP backend developer: Zend, Yii, PhalconPHP",
                        l5: "Frontend developer: Javascript, Less, Css3, HTML"
                    }
                },
                mazzmediaOld: {
                    location: "Milan - IT"
                },
                dservice: {
                    location: "Milan - IT"
                },
                contactlab: {
                    location: "Milan - IT"
                },
                mozart: {
                    location: "Milan - IT"
                },
                ridesoft: {
                    location: "Milan - IT"
                },
                miecube: {
                    location: "Milan - IT"
                },
                bicocca: {
                    location: "Milan - IT"
                },
                bmfactory: {
                    location: "Milan - IT"
                },
                easytech: {
                    location: "Milan - IT"
                },
                marketing: {
                    location: "Milan - IT"
                },
                gymnasium: {
                    location: "Milan - IT"
                },
                sap: {
                    certId: "Certification ID: 0004057568"
                }
            }
        },
        services: {
            meta: {
                title: "Maurizio Brioschi services: team leader, software architect, software engineer web, digital transformation expert",
                description: "Hire me as team lead, software architect or software engineer and let's work together to unlock the full potential of your software solutions on the road to digital transformation",
                keywords: "team leader, software architect, software engineer web, digital transformation expert"
            },
            title: "I can work as",
            teamLeader: {
                title: "Team Leader",
                hero: "Welcome to Your Next Level of Technical Leadership: Join Me as Your Dedicated Team Leader",
                intro: "Are you searching for a seasoned professional to lead your technical projects to success? Look no further. I offer expert technical leadership services tailored to your unique needs. As your dedicated team leader, I bring years of experience and a proven track record of delivering exceptional results. Here's what I bring to the table:",
                sections: {
                    s1: {
                        title: "Comprehensive Technical Leadership:",
                        body: "I provide end-to-end leadership for your technical projects, from initial planning to final delivery. With a keen eye for detail and a strategic mindset, I ensure that every aspect of your project is executed with precision and excellence."
                    },
                    s2: {
                        title: "Expert Guidance and Support:",
                        body: "As your team leader, I offer expert guidance and support to your team members, helping them navigate challenges, make informed decisions, and achieve their full potential. My hands-on approach fosters collaboration and empowers your team to excel."
                    },
                    s3: {
                        title: "Customized Solutions for Your Needs:",
                        body: "I understand that every project is unique. That's why I tailor my approach to meet your specific goals and requirements. Whether you need to streamline processes, improve efficiency, or overcome technical obstacles, I have the expertise to help you succeed."
                    },
                    s4: {
                        title: "Risk Mitigation and Problem-Solving:",
                        body: "I proactively identify and mitigate risks to ensure smooth project execution. With a focus on problem-solving and contingency planning, I keep your projects on track and minimize disruptions."
                    },
                    s5: {
                        title: "Continuous Improvement:",
                        body: "I believe in the power of continuous improvement. I regularly evaluate project performance, gather feedback, and implement lessons learned to optimize processes and drive success."
                    }
                },
                whyTitle: "Why Choose Me as Your Team Leader?",
                why: {
                    w1: "Proven Expertise: With a solid background in technical leadership, I bring valuable skills and insights to your projects.",
                    w2: "Dedication to Success: I am committed to delivering results that exceed your expectations and contribute to your long-term success.",
                    w3: "Collaborative Approach: I work closely with your team to build trust, foster collaboration, and achieve shared goals.",
                    w4: "Client Satisfaction: My ultimate goal is your satisfaction. I go above and beyond to ensure that you are thrilled with the outcomes of your projects."
                },
                closingTitle: "Ready to Take Your Projects to the Next Level?",
                closing: "Partner with me as your team leader, and let's embark on a journey of success together. Contact me today to discuss how I can support your technical projects and help you achieve your goals."
            },
            softwareArchitect: {
                title: "Software Architect",
                hero: "Unlock Your Software's Potential: Hire Me as Your Software Architect",
                intro: "Are you looking to build scalable, maintainable, and efficient software solutions? Look no further. As a seasoned software architect, I offer expert services tailored to your unique needs. Here's how I can help:",
                sections: {
                    s1: {
                        title: "Comprehensive Software Architecture:",
                        body: "I design comprehensive software architectures that align with your business goals and technical requirements. From system design to implementation, I ensure that your software solution is robust, scalable, and future-proof."
                    },
                    s2: {
                        title: "Technology Selection and Evaluation:",
                        body: "I help you choose the right technologies and tools for your project, considering factors such as scalability, performance, security, and cost-effectiveness. I conduct thorough evaluations and provide recommendations to ensure optimal technology stack selection."
                    },
                    s3: {
                        title: "Scalability and Performance Optimization:",
                        body: "I architect solutions that can scale with your business needs and handle increased loads efficiently. Through performance optimization techniques and architectural best practices, I ensure that your software performs optimally under all conditions."
                    },
                    s4: {
                        title: "Security and Compliance:",
                        body: "I prioritize security and compliance in every aspect of the software architecture. From data encryption to access control mechanisms, I implement robust security measures to protect your valuable assets and ensure regulatory compliance."
                    },
                    s5: {
                        title: "Team Collaboration and Leadership:",
                        body: "I collaborate closely with your development team, providing leadership, guidance, and mentorship throughout the software development lifecycle. I foster a collaborative environment where team members can thrive and deliver their best work."
                    },
                    s6: {
                        title: "Continuous Improvement and Innovation:",
                        body: "I believe in the power of continuous improvement and innovation. I stay updated on the latest industry trends and emerging technologies to ensure that your software remains cutting-edge and competitive in the ever-evolving market."
                    }
                },
                whyTitle: "Why Choose Me as Your Software Architect?",
                why: {
                    w1: "Extensive Experience: With years of experience in software architecture, I bring a wealth of knowledge and expertise to your projects.",
                    w2: "Customized Solutions: I tailor my approach to meet your specific needs and goals, ensuring that you get the best possible outcomes.",
                    w3: "Commitment to Excellence: I am committed to delivering software solutions of the highest quality that exceed your expectations.",
                    w4: "Client Satisfaction: My ultimate goal is your satisfaction. I work closely with you to understand your requirements and deliver solutions that meet or exceed your expectations."
                },
                closingTitle: "Ready to Elevate Your Software Solutions?",
                closing: "Hire me as your software architect, and let's work together to unlock the full potential of your software solutions. Contact me today to discuss your project requirements and how I can help you achieve your goals."
            },
            softwareEngineer: {
                title: "Software Engineer and developer",
                hero: "Empower Your Projects with Expert PHP, React.js, and Vue.js Development",
                intro: "Are you in need of a skilled software engineer and developer proficient in PHP, React.js, and Vue.js to enhance your projects? Look no further. I offer specialized services tailored to your needs in these technologies. Here's how I can contribute to your success:",
                sections: {
                    s1: {
                        title: "Custom Web Development:",
                        body: "I specialize in custom web development using PHP, React.js, and Vue.js to create dynamic and interactive web applications. Whether you need a robust backend system, a responsive front-end interface, or a full-stack solution, I have the expertise to deliver high-quality, scalable, and user-friendly applications."
                    },
                    s2: {
                        title: "Full-Stack Development:",
                        body: "I am proficient in both front-end and back-end development, allowing me to handle all aspects of software development. From database design to user interface implementation, I have the skills to develop comprehensive solutions that meet your specific requirements."
                    },
                    s3: {
                        title: "React.js and Vue.js Development:",
                        body: "I specialize in building dynamic and responsive user interfaces using React.js and Vue.js. Whether you need to develop single-page applications, progressive web apps, or interactive UI components, I leverage the power of these frameworks to create engaging user experiences."
                    },
                    s4: {
                        title: "Custom Plugin and Component Development:",
                        body: "I develop custom plugins and components for PHP-based applications as well as React.js and Vue.js projects. Whether you need to extend the functionality of existing systems or integrate third-party services, I can create tailored solutions to meet your specific needs."
                    },
                    s5: {
                        title: "Quality Assurance and Testing:",
                        body: "I prioritize quality assurance throughout the development process, conducting thorough testing to identify and resolve issues before they impact your users. I employ automated testing techniques and best practices to ensure that your software is reliable and bug-free."
                    },
                    s6: {
                        title: "Collaborative Approach:",
                        body: "I believe in transparent communication and collaboration with my clients. I work closely with you to understand your requirements, provide regular updates, and incorporate your feedback to ensure that the final product meets your expectations."
                    },
                    s7: {
                        title: "Continuous Learning and Improvement:",
                        body: "I am passionate about staying updated on the latest technologies and best practices in software development. I continually seek opportunities to enhance my skills and knowledge to deliver innovative solutions that drive your success."
                    }
                },
                whyTitle: "Why Choose Me as Your Software Engineer and Developer?",
                why: {
                    w1: "Extensive Experience: With years of experience in software engineering and development, I bring a depth of expertise to your projects.",
                    w2: "Specialized Skills: I specialize in PHP, React.js, and Vue.js development, offering specialized services tailored to your specific needs.",
                    w3: "Customized Solutions: I tailor my services to meet your unique requirements, ensuring that you receive solutions that are perfectly aligned with your goals.",
                    w4: "Reliability and Commitment: I am committed to delivering results of the highest quality on time and within budget."
                },
                closingTitle: "Ready to Empower Your Projects?",
                closing: "Hire me as your software engineer and developer, and let's collaborate to bring your ideas to life using PHP, React.js, and Vue.js. Contact me today to discuss your project requirements and how I can help you achieve your goals."
            },
            digitalTransformation: {
                title: "Digital transformation expert",
                hero: "Unlock Your Potential with Expert Digital Transformation and Agile Services",
                intro: "Are you ready to embrace digital transformation and Agile methodologies to drive innovation and growth in your organization? Look no further. I offer expert services tailored to help you navigate the complexities of digital transformation and implement Agile practices effectively. Here's how I can help:",
                sections: {
                    s1: {
                        title: "Digital Transformation Strategy:",
                        body: "I specialize in developing comprehensive digital transformation strategies that align with your business objectives and drive meaningful change. From assessing your current state to defining a roadmap for transformation, I work closely with you to ensure that your digital initiatives deliver maximum value."
                    },
                    s2: {
                        title: "Agile Implementation and Coaching:",
                        body: "I have extensive experience in implementing Agile methodologies such as Scrum, Kanban, and Lean within organizations of all sizes. Whether you're new to Agile or looking to optimize your existing processes, I provide hands-on coaching and support to help your teams embrace Agile principles and practices."
                    },
                    s3: {
                        title: "Digital Innovation and Disruption:",
                        body: "I help organizations harness the power of digital technologies to drive innovation and disrupt traditional business models. From adopting cloud computing and artificial intelligence to leveraging data analytics and IoT, I empower you to stay ahead of the curve and capitalize on emerging opportunities."
                    },
                    s4: {
                        title: "Organizational Change Management:",
                        body: "I understand that digital transformation is not just about technology—it's also about people and processes. I provide change management support to help your organization adapt to new ways of working, overcome resistance to change, and foster a culture of continuous improvement."
                    },
                    s5: {
                        title: "Collaborative Approach:",
                        body: "I believe in working collaboratively with your teams and stakeholders to co-create solutions that drive meaningful results. I facilitate workshops, meetings, and retrospectives to ensure alignment, transparency, and accountability throughout the transformation journey."
                    },
                    s6: {
                        title: "Continuous Learning and Improvement:",
                        body: "I am passionate about staying updated on the latest trends and best practices in digital transformation and Agile methodologies. I continually seek opportunities to enhance my skills and knowledge to deliver innovative solutions that drive your organization's success."
                    }
                },
                whyTitle: "Why Choose Me for Your Digital Transformation and Agile Initiatives?",
                why: {
                    w1: "Expertise and Experience: With a proven track record in digital transformation and Agile, I bring valuable insights and expertise to your projects.",
                    w2: "Customized Solutions: I tailor my services to meet your specific needs and goals, ensuring that you achieve the desired outcomes of your digital initiatives.",
                    w3: "Collaborative Approach: I work closely with your teams and stakeholders to ensure alignment, transparency, and accountability throughout the transformation journey.",
                    w4: "Commitment to Success: I am dedicated to your success and strive to deliver results of the highest quality on time and within budget."
                },
                closingTitle: "Ready to Embrace Digital Transformation and Agile?",
                closing: "Partner with me to unlock the full potential of your organization through digital transformation and Agile methodologies. Contact me today to discuss your goals and how I can help you achieve them."
            }
        },
        contacts: {
            meta: {
                title: "Maurizio Brioschi contacts: where to find me and how to stay connected",
                description: "Find Maurizio Brioschi address, email, phone and social networks. Contact me today to discuss how I can support your technical projects and help you achieve your goals.",
                keywords: "email, address, social networks, mobile, phone, linkedin, github"
            },
            title: "How to contact me?",
            addressLine: "Maurizio Brioschi - via Amsicora 46 - 09072 Cabras (OR) - Sardegna - Italy",
            mapTitle: "Maurizio Brioschi address"
        },
        references: {
            meta: {
                title: "Maurizio Brioschi references: check what people say about me and companies references",
                description: "References and stories about me, what was done well during the years",
                keywords: "references, career, jobs, companies, people, stories"
            },
            title: "My references"
        },
        works: {
            title: "I worked and developed",
            cards: {
                teatro: {
                    title: "Teatro.it",
                    description: "The main portal about theaters in Italy",
                    imgAlt: "Screenshot of the Teatro.it project",
                    bullets: {
                        b1: "Managed a team of 5",
                        b2: "Migration and platform evolution"
                    }
                }
            }
        },
        projects: {
            title: "Projects"
        },
        error: {
            message: "An error occurred, couldn't find the page."
        },
        homeBanner: {
            learnMore: "Learn more"
        }
    },
    it: {
        language: {
            label: "Lingua",
            options: {
                en: "English",
                it: "Italiano",
                de: "Deutsch"
            }
        },
        nav: {
            home: "Home",
            about: "Chi sono",
            services: "Servizi",
            references: "Referenze",
            contacts: "Contatti",
            projects: "Progetti",
            works: "Lavori"
        },
        footer: {
            cv: "Curriculum vitae"
        },
        reviews: {
            translationLabel: "Italiano",
            originalLabel: "Originale"
        },
        home: {
            meta: {
                title: "Maurizio Brioschi: Team leader, architetto software, ingegnere del software web ed esperto di trasformazione digitale freelance",
                description: "Potenzia il tuo percorso digitale con un team freelance versatile guidato da esperti in architettura software, ingegneria e trasformazione digitale. Dalla guida strategica all'implementazione operativa, conduco la rotta tra le complessità del moderno sviluppo web. Scopri come possiamo portare i tuoi progetti a un livello superiore.",
                keywords: "freelancer, team leader, architetto software, ingegnere del software, sviluppo web, trasformazione digitale"
            },
            carousel: [
                {
                    title: "Team leader",
                    description: "Team leader esperto e dedicato, capace di favorire la collaborazione, guidare i risultati e valorizzare i membri del team. Abile nella pianificazione strategica, nel problem solving e nel creare una cultura positiva per raggiungere gli obiettivi organizzativi."
                },
                {
                    title: "Architetto software",
                    description: "Architetto software dinamico con una comprovata esperienza nella progettazione e realizzazione di soluzioni robuste e scalabili. Capace di tradurre requisiti complessi in architetture innovative, guidare l'eccellenza tecnica e garantire l'allineamento alle best practice del settore."
                },
                {
                    title: "Ingegnere del software web",
                    description: "Ingegnere del software appassionato con solide basi in programmazione, test e debugging. Esperto nel collaborare con team internazionali cross-funzionali per consegnare soluzioni di alta qualità, imparando e adattandosi continuamente a nuove tecnologie."
                }
            ],
            offer: {
                label: "Estate 2026",
                title: "Offerta stagionale per attività estive in Sardegna",
                description: "Una landing chiara e ottimizzata per telefono, pensata per ricevere richieste e prenotazioni.",
                cta: "Scopri l’offerta"
            },
            storiesTitle: "Storie su di me",
            readAll: "Leggi tutto"
        },
        about: {
            meta: {
                title: "Maurizio Brioschi: tutte le tappe più importanti della mia carriera per diventare team leader, architetto software e ingegnere del software",
                description: "Tutte le tappe della carriera di Maurizio Brioschi nel percorso per diventare team leader, architetto software e ingegnere. Scarica il mio CV per scoprire tutte le aziende, gli studi e i lavori svolti.",
                keywords: "freelancer, cv, curriculum vitae, carriera, lavori, aziende, studi, formazione, famiglia"
            },
            title: "La mia carriera",
            certifications: {
                linkLabel: "Link certificazione"
            },
            timeline: {
                t2023_present: "Febbraio 2023 - Oggi",
                t2022_oct_2023_nov: "Ottobre 2022 - Novembre 2023",
                t2022_feb_2023_jan: "Febbraio 2022 - Gennaio 2023",
                t2022_oct: "Ottobre 2022",
                t2020_jun: "Giugno 2020",
                t2020_aug: "Agosto 2020",
                t2019_jul_2022_jan: "Luglio 2019 - Gennaio 2022",
                t2019_apr_2019_jul: "Aprile 2019 - Luglio 2019",
                t2018_nov_2019_mar: "Novembre 2018 - Marzo 2019",
                t2018_feb: "Febbraio 2018",
                t2017_apr_2018_may: "Aprile 2017 - Maggio 2018",
                t2015_oct_2017_mar: "Ottobre 2015 - Marzo 2017",
                t2015_sep: "Settembre 2015",
                t2015_may_2015_sep: "Maggio 2015 - Settembre 2015",
                t2015_apr: "Aprile 2015",
                t2014_nov_2015_apr: "Novembre 2014 - Aprile 2015",
                t2015_feb: "Febbraio 2015",
                t2014_sep: "Settembre 2014",
                t2014_may_2014_nov: "Maggio 2014 - Novembre 2014",
                t2015_oct_2017_mar_dup: "Ottobre 2015 - Marzo 2017",
                t2012_may_2013_jan: "Maggio 2012 - Gennaio 2013",
                t2007_feb_2013_feb: "Febbraio 2007 - Febbraio 2013",
                t2006_may: "Maggio 2006",
                t2006_sep_2011_mar: "Settembre 2006 - Marzo 2011",
                t2006_apr: "Aprile 2006",
                t2002_feb_2012_dec: "Febbraio 2002 - Dicembre 2012",
                t2005_apr_2005_oct: "Aprile 2005 - Ottobre 2005",
                t2000_2002: "2000 - 2002",
                t2000_jun: "Giugno 2000"
            },
            roles: {
                solutionArchitect: "Software/Solution Architect e Technical Lead",
                cto: "Chief Technology Officer",
                seniorEngineer: "Senior software engineer",
                sonBorn: "È nato mio figlio Manuel",
                adobeCert: "Adobe Certified Expert - Adobe Commerce Cloud Developer",
                movedSardinia: "Trasferimento in Sardegna",
                techLeader: "Technical Leader - Senior Engineer",
                seniorBackend: "Senior Backend Engineer",
                seniorSoftwareEngineer: "Senior Software Engineer",
                gkeCert: "Introduzione a Google Kubernetes Engine",
                limangoSenior: "Senior Software Engineer",
                mothershipSenior: "Senior Developer",
                movedMunich: "Trasferimento a Monaco di Baviera",
                shopwingsSenior: "Senior Developer",
                movedBerlin: "Trasferimento a Berlino",
                itLeadDeveloper: "IT Lead Developer",
                gotMarried: "Mi sono sposato",
                daughterBorn: "È nata mia figlia Mia",
                dserviceSenior: "Senior Developer",
                contactlabDev: "Software Developer",
                seniorWebDev: "Senior Web developer",
                ownerCto: "Founder e CTO",
                sapConsultant: "Consultant di sviluppo SAP SDK",
                analystProgrammer: "Analista e programmatore coinvolto anche nella parte database per un'applicazione web 2.0",
                bachelor: "Laurea in Informatica",
                analystDeveloper: "Analista, programmatore e sviluppatore software",
                programmer: "Programmatore",
                systemist: "Sistemista",
                gymnasium: "Diploma di liceo scientifico"
            },
            items: {
                mazzmedia: {
                    location: "Milano - Italia",
                    list: {
                        l1: "Technical leader: gestione di 4 sviluppatori e dei requisiti cliente",
                        l2: "Architetto software e infrastrutturale su cloud (AWS) con architettura AWS ECS",
                        l3: "Manutenzione dell'ambiente di sviluppo Docker",
                        l4: "Creazione pipeline per continuous delivery",
                        l5: "Responsabile del workflow di progetto e Agile",
                        l6: "Responsabile della qualità del codice tramite code review, test, logging e monitoraggio performance",
                        l7: "Sviluppo (Laravel, Reactjs, Vuejs, Wordpress, Prestashop, Magento)",
                        l8: "Ottimizzazioni di siti web"
                    }
                },
                palco: {
                    location: "Londra - Regno Unito",
                    list: {
                        l1: "Manutenzione SaaS su cloud (Linode - AWS)",
                        l2: "Tech leader e developer (Laravel - Reactjs)"
                    }
                },
                newporttakkt: {
                    location: "Stoccarda - Germania",
                    list: {
                        l1: "Architettura software",
                        l2: "Sviluppo Shopware",
                        l3: "Ottimizzazioni software",
                        l4: "Code review"
                    }
                },
                mediawave: {
                    location: "Monaco di Baviera - Germania",
                    list: {
                        l1: "Technical/team leader: gestione di 4 sviluppatori e requisiti cliente",
                        l2: "Parte del processo di selezione, conduzione di colloqui per i candidati",
                        l3: "Responsabile qualità del codice tramite code review, test, logging e monitoraggio performance",
                        l4: "Manutentore Magento cloud",
                        l5: "Manutenzione dell'ambiente di sviluppo Docker",
                        l6: "Architettura software di progetti Magento 2 con: RabbitMq, RestApi, integrazioni CRM, GraphQL, Elasticsearch",
                        l7: "Creazione pipeline per continuous delivery in GitLab",
                        l8: "Sviluppo Magento 2",
                        l9: "Sviluppo e architettura configuratore prodotto in Vue.js integrato in Dynamics365",
                        l10: "Sviluppo React per progetto PWA Studio"
                    }
                },
                vitafy: {
                    location: "Monaco di Baviera - Germania",
                    list: {
                        l1: "Sviluppatore Magento 1",
                        l2: "Sviluppatore Node.js",
                        l3: "Attività DevOps relative a Docker e ottimizzazioni GitLab CI"
                    }
                },
                burda: {
                    location: "Monaco di Baviera - Germania",
                    list: {
                        l1: "DevOps: nuovo ambiente di sviluppo con Docker e manutenzione immagini Docker",
                        l2: "Sviluppatore Drupal"
                    }
                },
                limango: {
                    location: "Monaco di Baviera - Germania",
                    list: {
                        l1: "Senior backend developer: Laravel, MySql, Javascript, RabbitMq, Elasticsearch",
                        l2: "Microservizio ordine fornitori",
                        l3: "Responsabilità qualità del codice: test, stile, documentazione",
                        l4: "Membro del core group API"
                    }
                },
                mothership: {
                    location: "Monaco di Baviera - Germania",
                    list: {
                        l1: "Backend developer: ottimizzazioni sito web con creazione di estensioni e moduli",
                        l2: "Sviluppatore Magento",
                        l3: "Refactory shop Exxpozed: responsabilità principali su import e sincronizzazione dati da PIM a Magento; sviluppo modulo di gestione DB Magento in Elasticsearch; libreria schedulazione job in Rabbitmq; integrazione Emarsys per marketing; fix PHP7.",
                        l4: "Sviluppo e manutenzione delle librerie core aziendali",
                        l5: "Code review"
                    },
                    linkLabel: "Refactory shop Exxpozed",
                    githubLabel: "https://github.com/mothership-gmbh"
                },
                shopwings: {
                    location: "Berlino - Germania",
                    list: {
                        l1: "Amministratore Vagrant e Puppet",
                        l2: "Sviluppo Symfony2 per applicazione web e API",
                        l3: "TDD per API – PHPUnit - Raml",
                        l4: "Senior PHP backend developer: Zend, Yii, PhalconPHP",
                        l5: "Frontend developer: Javascript, Less, Css3, HTML"
                    }
                },
                mazzmediaOld: {
                    location: "Milano - Italia"
                },
                dservice: {
                    location: "Milano - Italia"
                },
                contactlab: {
                    location: "Milano - Italia"
                },
                mozart: {
                    location: "Milano - Italia"
                },
                ridesoft: {
                    location: "Milano - Italia"
                },
                miecube: {
                    location: "Milano - Italia"
                },
                bicocca: {
                    location: "Milano - Italia"
                },
                bmfactory: {
                    location: "Milano - Italia"
                },
                easytech: {
                    location: "Milano - Italia"
                },
                marketing: {
                    location: "Milano - Italia"
                },
                gymnasium: {
                    location: "Milano - Italia"
                },
                sap: {
                    certId: "ID certificazione: 0004057568"
                }
            }
        },
        services: {
            meta: {
                title: "Servizi di Maurizio Brioschi: team leader, architetto software, ingegnere del software web, esperto di trasformazione digitale",
                description: "Assumimi come team lead, architetto software o ingegnere del software e lavoriamo insieme per sbloccare il pieno potenziale delle tue soluzioni software sulla strada della trasformazione digitale",
                keywords: "team leader, architetto software, ingegnere del software web, esperto di trasformazione digitale"
            },
            title: "Lavoro come",
            teamLeader: {
                title: "Team Leader",
                hero: "Un team leader per guidare il vostro team sui vostri progetti",
                intro: "State cercando un professionista esperto per guidare i vostri progetti tecnici al successo? Offro servizi di leadership tecnica su misura per le vostre esigenze. Come vostro team leader dedicato, porto anni di esperienza e un track record di risultati eccellenti:",
                sections: {
                    s1: {
                        title: "Leadership tecnica completa:",
                        body: "Guida end-to-end per i vostri progetti tecnici, dalla pianificazione iniziale alla consegna finale. Con un occhio attento ai dettagli e una mentalità strategica, mi assicuro che ogni aspetto del progetto sia eseguito con precisione ed eccellenza."
                    },
                    s2: {
                        title: "Guida e supporto esperti:",
                        body: "Come team leader, offro guida e supporto ai membri del team, aiutandoli a superare le sfide, prendere decisioni informate e raggiungere il loro pieno potenziale. Il mio approccio pratico favorisce collaborazione e crescita."
                    },
                    s3: {
                        title: "Soluzioni personalizzate:",
                        body: "Ogni progetto è unico. Adatto il mio approccio ai vostri obiettivi e requisiti specifici. Che si tratti di ottimizzare processi, migliorare l'efficienza o superare ostacoli tecnici, ho l'esperienza per aiutarvi a ottenere successo."
                    },
                    s4: {
                        title: "Mitigazione dei rischi e problem solving:",
                        body: "Identifico e mitigo proattivamente i rischi per garantire un'esecuzione fluida. Con focus su problem solving e piani di contingenza, mantengo i progetti in rotta e riduco le interruzioni."
                    },
                    s5: {
                        title: "Miglioramento continuo:",
                        body: "Credo nel miglioramento continuo. Valuto regolarmente le performance, raccolgo feedback e implemento le lezioni apprese per ottimizzare processi e risultati."
                    }
                },
                whyTitle: "Perché scegliermi come vostro team leader?",
                why: {
                    w1: "Competenza comprovata: con una solida esperienza in leadership tecnica, porto competenze e insight preziosi ai vostri progetti.",
                    w2: "Dedizione al successo: sono impegnato a fornire risultati che superano le vostre aspettative e contribuiscono al successo di lungo periodo.",
                    w3: "Approccio collaborativo: lavoro a stretto contatto con il vostro team per costruire fiducia, favorire collaborazione e raggiungere obiettivi condivisi.",
                    w4: "Soddisfazione del cliente: il mio obiettivo è la vostra soddisfazione. Vado oltre il necessario per garantire risultati eccellenti."
                },
                closingTitle: "Pronti a portare i vostri progetti al livello successivo?",
                closing: "Collaborate con me come team leader e intraprendiamo un percorso di successo. Contattatemi per discutere come posso supportare i vostri progetti tecnici e aiutarvi a raggiungere i vostri obiettivi."
            },
            softwareArchitect: {
                title: "Architetto software",
                hero: "Sblocca il potenziale del tuo software: assumimi come architetto software",
                intro: "Vuoi costruire soluzioni software scalabili, manutenibili ed efficienti? Come architetto software offro servizi su misura per le tue esigenze. Ecco come posso aiutarti:",
                sections: {
                    s1: {
                        title: "Architettura software completa:",
                        body: "Progetto architetture che si allineano con obiettivi di business e requisiti tecnici. Dalla progettazione all'implementazione, garantisco soluzioni robuste, scalabili e future-proof."
                    },
                    s2: {
                        title: "Selezione e valutazione tecnologie:",
                        body: "Ti aiuto a scegliere tecnologie e strumenti giusti considerando scalabilità, performance, sicurezza e costi. Conduco valutazioni approfondite per uno stack ottimale."
                    },
                    s3: {
                        title: "Scalabilità e ottimizzazione delle prestazioni:",
                        body: "Architetto soluzioni in grado di scalare e gestire carichi crescenti. Con tecniche di ottimizzazione e best practice, garantisco prestazioni ottimali in ogni condizione."
                    },
                    s4: {
                        title: "Sicurezza e conformità:",
                        body: "La sicurezza e la conformità sono priorità. Dalla cifratura ai controlli di accesso, implemento misure robuste per proteggere gli asset e rispettare i requisiti normativi."
                    },
                    s5: {
                        title: "Collaborazione e leadership del team:",
                        body: "Collaboro con il team di sviluppo offrendo leadership, guida e mentorship durante l'intero ciclo di vita del software. Creo un ambiente collaborativo e produttivo."
                    },
                    s6: {
                        title: "Miglioramento continuo e innovazione:",
                        body: "Resto aggiornato su trend e tecnologie emergenti per garantire che il software rimanga competitivo in un mercato in continua evoluzione."
                    }
                },
                whyTitle: "Perché scegliermi come architetto software?",
                why: {
                    w1: "Esperienza estesa: porto anni di esperienza e competenze maturate in architettura software.",
                    w2: "Soluzioni personalizzate: adatto l'approccio alle tue esigenze e obiettivi specifici.",
                    w3: "Impegno per l'eccellenza: consegno soluzioni di altissima qualità che superano le aspettative.",
                    w4: "Soddisfazione del cliente: lavoro a stretto contatto con te per soddisfare requisiti e obiettivi."
                },
                closingTitle: "Pronto a elevare le tue soluzioni software?",
                closing: "Assumimi come architetto software e lavoriamo insieme per sbloccare il pieno potenziale delle tue soluzioni. Contattami per discutere requisiti e obiettivi."
            },
            softwareEngineer: {
                title: "Ingegnere del software e developer",
                hero: "Potenzia i tuoi progetti con sviluppo esperto in PHP, React.js e Vue.js",
                intro: "Hai bisogno di un ingegnere del software e sviluppatore esperto in PHP, React.js e Vue.js? Offro servizi specializzati su misura per queste tecnologie. Ecco come posso contribuire al tuo successo:",
                sections: {
                    s1: {
                        title: "Sviluppo web personalizzato:",
                        body: "Mi specializzo nello sviluppo web personalizzato usando PHP, React.js e Vue.js per creare applicazioni dinamiche e interattive. Che tu abbia bisogno di un backend robusto, di un front-end responsive o di una soluzione full-stack, posso consegnare applicazioni scalabili e user-friendly."
                    },
                    s2: {
                        title: "Sviluppo full-stack:",
                        body: "Sono competente sia nello sviluppo front-end che back-end, gestendo tutti gli aspetti dello sviluppo software. Dalla progettazione del database all'interfaccia utente, sviluppo soluzioni complete."
                    },
                    s3: {
                        title: "Sviluppo React.js e Vue.js:",
                        body: "Creo interfacce utente dinamiche e responsive con React.js e Vue.js. Che si tratti di SPA, PWA o componenti UI interattivi, sfrutto la potenza di questi framework."
                    },
                    s4: {
                        title: "Sviluppo di plugin e componenti personalizzati:",
                        body: "Sviluppo plugin e componenti personalizzati per applicazioni PHP e per progetti React.js e Vue.js. Posso estendere sistemi esistenti o integrare servizi di terze parti."
                    },
                    s5: {
                        title: "Quality assurance e test:",
                        body: "Do priorità alla qualità durante tutto il processo, con test approfonditi per individuare e risolvere problemi prima che impattino gli utenti. Uso tecniche di test automatizzato e best practice."
                    },
                    s6: {
                        title: "Approccio collaborativo:",
                        body: "Credo nella comunicazione trasparente e nella collaborazione con i clienti. Lavoro a stretto contatto con te, fornendo aggiornamenti regolari e integrando il tuo feedback."
                    },
                    s7: {
                        title: "Apprendimento continuo e miglioramento:",
                        body: "Resto aggiornato su tecnologie e best practice. Cerco continuamente opportunità per migliorare competenze e conoscenze e offrire soluzioni innovative."
                    }
                },
                whyTitle: "Perché scegliermi come ingegnere del software e developer?",
                why: {
                    w1: "Esperienza estesa: anni di esperienza in ingegneria del software e sviluppo.",
                    w2: "Competenze specializzate: specializzato in PHP, React.js e Vue.js.",
                    w3: "Soluzioni personalizzate: servizi su misura per obiettivi specifici.",
                    w4: "Affidabilità e impegno: risultati di alta qualità nei tempi e nel budget."
                },
                closingTitle: "Pronto a potenziare i tuoi progetti?",
                closing: "Assumimi come ingegnere del software e developer e collaboriamo per dare vita alle tue idee con PHP, React.js e Vue.js. Contattami per discutere requisiti e obiettivi."
            },
            digitalTransformation: {
                title: "Esperto di trasformazione digitale",
                hero: "Sblocca il tuo potenziale con servizi esperti di trasformazione digitale e Agile",
                intro: "Sei pronto ad abbracciare la trasformazione digitale e le metodologie Agile per guidare innovazione e crescita? Offro servizi su misura per aiutarti a navigare le complessità e implementare efficacemente le pratiche Agile. Ecco come posso aiutare:",
                sections: {
                    s1: {
                        title: "Strategia di trasformazione digitale:",
                        body: "Sviluppo strategie complete allineate agli obiettivi aziendali. Dalla valutazione dello stato attuale alla definizione della roadmap, lavoro con te per massimizzare il valore delle iniziative digitali."
                    },
                    s2: {
                        title: "Implementazione e coaching Agile:",
                        body: "Ho esperienza nell'implementare Scrum, Kanban e Lean in organizzazioni di ogni dimensione. Offro coaching pratico per adottare principi e pratiche Agile."
                    },
                    s3: {
                        title: "Innovazione e disruption digitale:",
                        body: "Aiuto le organizzazioni a sfruttare tecnologie digitali per innovare e trasformare i modelli di business. Dal cloud e AI all'analisi dati e IoT, ti aiuto a cogliere nuove opportunità."
                    },
                    s4: {
                        title: "Gestione del cambiamento organizzativo:",
                        body: "La trasformazione digitale riguarda anche persone e processi. Fornisco supporto al change management per superare resistenze e creare una cultura di miglioramento continuo."
                    },
                    s5: {
                        title: "Approccio collaborativo:",
                        body: "Lavoro in collaborazione con team e stakeholder per co-creare soluzioni che generino risultati concreti. Facilito workshop, riunioni e retrospettive per garantire allineamento e trasparenza."
                    },
                    s6: {
                        title: "Apprendimento continuo e miglioramento:",
                        body: "Resto aggiornato su trend e best practice di trasformazione digitale e Agile. Cerco continuamente opportunità per migliorare competenze e offrire soluzioni innovative."
                    }
                },
                whyTitle: "Perché scegliermi per la tua trasformazione digitale e iniziative Agile?",
                why: {
                    w1: "Competenza ed esperienza: track record comprovato in trasformazione digitale e Agile.",
                    w2: "Soluzioni personalizzate: servizi su misura per obiettivi specifici.",
                    w3: "Approccio collaborativo: allineamento e accountability lungo il percorso.",
                    w4: "Impegno per il successo: risultati di alta qualità nei tempi e nel budget."
                },
                closingTitle: "Pronto ad abbracciare la trasformazione digitale e Agile?",
                closing: "Collabora con me per sbloccare il pieno potenziale della tua organizzazione attraverso trasformazione digitale e Agile. Contattami per discutere obiettivi e priorità."
            }
        },
        contacts: {
            meta: {
                title: "Contatti Maurizio Brioschi: dove trovarmi e come restare in contatto",
                description: "Trova indirizzo, email, telefono e social di Maurizio Brioschi. Contattami per discutere come posso supportare i tuoi progetti tecnici e aiutarti a raggiungere i tuoi obiettivi.",
                keywords: "email, indirizzo, social, cellulare, telefono, linkedin, github"
            },
            title: "Come contattarmi?",
            addressLine: "Maurizio Brioschi - via Amsicora 46 - 09072 Cabras (OR) - Sardegna - Italia",
            mapTitle: "Indirizzo Maurizio Brioschi"
        },
        references: {
            meta: {
                title: "Referenze Maurizio Brioschi: cosa dicono di me e referenze aziendali",
                description: "Referenze e storie su di me, ciò che è stato fatto bene negli anni",
                keywords: "referenze, carriera, lavori, aziende, persone, storie"
            },
            title: "Le mie referenze"
        },
        works: {
            title: "Ho lavorato e sviluppato",
            cards: {
                teatro: {
                    title: "Teatro.it",
                    description: "Il principale portale sui teatri in Italia",
                    imgAlt: "Schermata del progetto Teatro.it",
                    bullets: {
                        b1: "Gestione di un team di 5 persone",
                        b2: "Migrazione ed evoluzione della piattaforma"
                    }
                }
            }
        },
        projects: {
            title: "Progetti"
        },
        error: {
            message: "Si è verificato un errore, impossibile trovare la pagina."
        },
        homeBanner: {
            learnMore: "Scopri di più"
        }
    },
    de: {
        language: {
            label: "Sprache",
            options: {
                en: "English",
                it: "Italiano",
                de: "Deutsch"
            }
        },
        nav: {
            home: "Startseite",
            about: "Über mich",
            services: "Leistungen",
            references: "Referenzen",
            contacts: "Kontakt",
            projects: "Projekte",
            works: "Arbeiten"
        },
        footer: {
            cv: "Lebenslauf"
        },
        reviews: {
            translationLabel: "Italienisch",
            originalLabel: "Original"
        },
        home: {
            meta: {
                title: "Maurizio Brioschi: Teamleiter, Softwarearchitekt, Web-Softwareentwickler und Experte für digitale Transformation (Freelance)",
                description: "Stärken Sie Ihre digitale Reise mit einem vielseitigen Freelance-Team unter der Leitung von Experten für Softwarearchitektur, Engineering und digitale Transformation. Von strategischer Beratung bis zur praktischen Umsetzung führe ich Sie durch die Komplexität moderner Webentwicklung. Entdecken Sie, wie wir Ihre Projekte auf das nächste Level bringen.",
                keywords: "freelancer, teamleiter, softwarearchitekt, softwareentwickler, webentwicklung, digitale transformation"
            },
            carousel: [
                {
                    title: "Teamleiter",
                    description: "Erfahrener und engagierter Teamleiter, der Zusammenarbeit fördert, Ergebnisse liefert und Teammitglieder stärkt. Stark in strategischer Planung, Problemlösung und dem Aufbau einer positiven Teamkultur zur Erreichung organisatorischer Ziele."
                },
                {
                    title: "Softwarearchitekt",
                    description: "Dynamischer Softwarearchitekt mit nachweislicher Erfahrung in der Gestaltung und Umsetzung robuster, skalierbarer Softwarelösungen. Übersetzt komplexe Business-Anforderungen in innovative Architekturen, treibt technische Exzellenz und sorgt für Best-Practice-Ausrichtung."
                },
                {
                    title: "Web-Softwareentwickler",
                    description: "Leidenschaftlicher Softwareentwickler mit soliden Grundlagen in Programmierung, Testing und Debugging. Erfahren in der Zusammenarbeit mit internationalen, funktionsübergreifenden Teams, um hochwertige Lösungen zu liefern und sich kontinuierlich an neue Technologien anzupassen."
                }
            ],
            offer: {
                label: "Sommer 2026",
                title: "Saisonale Landingpages für lokale Betriebe in Sardinien",
                description: "Eine klare, mobile‑freundliche Landingpage für Buchungen und Anfragen in der Sommersaison.",
                cta: "Angebot ansehen"
            },
            storiesTitle: "Geschichten über mich",
            readAll: "Alle ansehen"
        },
        about: {
            meta: {
                title: "Maurizio Brioschi: alle wichtigen Stationen meiner Karriere auf dem Weg zum Teamleiter, Softwarearchitekten und Softwareentwickler",
                description: "Alle Stationen der Karriere von Maurizio Brioschi auf dem Weg zum Teamleiter, Softwarearchitekten und Softwareentwickler. Laden Sie meinen Lebenslauf herunter, um Unternehmen, Studien und Tätigkeiten zu entdecken.",
                keywords: "freelancer, lebenslauf, cv, karriere, jobs, unternehmen, studium, ausbildung, familie"
            },
            title: "Meine Karriere",
            certifications: {
                linkLabel: "Zertifikatslink"
            },
            timeline: {
                t2023_present: "Februar 2023 - Heute",
                t2022_oct_2023_nov: "Oktober 2022 - November 2023",
                t2022_feb_2023_jan: "Februar 2022 - Januar 2023",
                t2022_oct: "Oktober 2022",
                t2020_jun: "Juni 2020",
                t2020_aug: "August 2020",
                t2019_jul_2022_jan: "Juli 2019 - Januar 2022",
                t2019_apr_2019_jul: "April 2019 - Juli 2019",
                t2018_nov_2019_mar: "November 2018 - März 2019",
                t2018_feb: "Februar 2018",
                t2017_apr_2018_may: "April 2017 - Mai 2018",
                t2015_oct_2017_mar: "Oktober 2015 - März 2017",
                t2015_sep: "September 2015",
                t2015_may_2015_sep: "Mai 2015 - September 2015",
                t2015_apr: "April 2015",
                t2014_nov_2015_apr: "November 2014 - April 2015",
                t2015_feb: "Februar 2015",
                t2014_sep: "September 2014",
                t2014_may_2014_nov: "Mai 2014 - November 2014",
                t2015_oct_2017_mar_dup: "Oktober 2015 - März 2017",
                t2012_may_2013_jan: "Mai 2012 - Januar 2013",
                t2007_feb_2013_feb: "Februar 2007 - Februar 2013",
                t2006_may: "Mai 2006",
                t2006_sep_2011_mar: "September 2006 - März 2011",
                t2006_apr: "April 2006",
                t2002_feb_2012_dec: "Februar 2002 - Dezember 2012",
                t2005_apr_2005_oct: "April 2005 - Oktober 2005",
                t2000_2002: "2000 - 2002",
                t2000_jun: "Juni 2000"
            },
            roles: {
                solutionArchitect: "Software-/Solution-Architekt und Technical Lead",
                cto: "Chief Technology Officer",
                seniorEngineer: "Senior Software Engineer",
                sonBorn: "Mein Sohn Manuel wurde geboren",
                adobeCert: "Adobe Certified Expert - Adobe Commerce Cloud Developer",
                movedSardinia: "Umzug nach Sardinien",
                techLeader: "Technical Leader - Senior Engineer",
                seniorBackend: "Senior Backend Engineer",
                seniorSoftwareEngineer: "Senior Software Engineer",
                gkeCert: "Einstieg in Google Kubernetes Engine",
                limangoSenior: "Senior Software Engineer",
                mothershipSenior: "Senior Developer",
                movedMunich: "Umzug nach München",
                shopwingsSenior: "Senior Developer",
                movedBerlin: "Umzug nach Berlin",
                itLeadDeveloper: "IT Lead Developer",
                gotMarried: "Ich habe geheiratet",
                daughterBorn: "Meine Tochter Mia wurde geboren",
                dserviceSenior: "Senior Developer",
                contactlabDev: "Software Developer",
                seniorWebDev: "Senior Web Developer",
                ownerCto: "Owner und CTO",
                sapConsultant: "Entwicklungsberater SAP SDK",
                analystProgrammer: "Analyst und Programmierer, auch mit Datenbankanteil für eine Web-2.0-Anwendung",
                bachelor: "Bachelorabschluss in Informatik",
                analystDeveloper: "Analyst, Programmierer und Softwareentwickler",
                programmer: "Programmierer",
                systemist: "Systemadministrator",
                gymnasium: "Abschluss am naturwissenschaftlichen Gymnasium"
            },
            items: {
                mazzmedia: {
                    location: "Mailand - Italien",
                    list: {
                        l1: "Technical Leader: Leitung von 4 Entwicklern und Kundenanforderungen",
                        l2: "Software- und Infrastrukturarchitekt in der Cloud (AWS) mit AWS ECS Architektur",
                        l3: "Betreuung der Docker-Entwicklungsumgebung",
                        l4: "Aufbau von CI/CD-Pipelines",
                        l5: "Verantwortlich für Projekt-Workflow und Agile",
                        l6: "Verantwortlich für Codequalität durch Code Reviews, Testing, Logging und Performance Monitoring",
                        l7: "Entwicklung (Laravel, Reactjs, Vuejs, Wordpress, Prestashop, Magento)",
                        l8: "Website-Optimierungen"
                    }
                },
                palco: {
                    location: "London - Vereinigtes Königreich",
                    list: {
                        l1: "SaaS-Betreuung in der Cloud (Linode - AWS)",
                        l2: "Tech Lead und Entwickler (Laravel - Reactjs)"
                    }
                },
                newporttakkt: {
                    location: "Stuttgart - Deutschland",
                    list: {
                        l1: "Softwarearchitektur",
                        l2: "Shopware-Entwicklung",
                        l3: "Software-Optimierungen",
                        l4: "Code Reviews"
                    }
                },
                mediawave: {
                    location: "München - Deutschland",
                    list: {
                        l1: "Technical/Team Lead: Leitung von 4 Entwicklern und Kundenanforderungen",
                        l2: "Teil des Recruiting-Prozesses, Durchführung von Interviews",
                        l3: "Verantwortlich für Codequalität durch Code Reviews, Testing, Logging und Performance Monitoring",
                        l4: "Magento-Cloud-Betreuer",
                        l5: "Betreuung der Docker-Entwicklungsumgebung",
                        l6: "Softwarearchitektur von Magento-2-Projekten mit: RabbitMq, RestApi, CRM-Integrationen, GraphQL, Elasticsearch",
                        l7: "Aufbau von CI/CD-Pipelines in GitLab",
                        l8: "Magento-2-Entwicklung",
                        l9: "Produktkonfigurator-Entwicklung und -Architektur in Vue.js integriert in Dynamics365",
                        l10: "React-Entwicklung für PWA Studio"
                    }
                },
                vitafy: {
                    location: "München - Deutschland",
                    list: {
                        l1: "Magento-1-Entwickler",
                        l2: "Node.js-Entwickler",
                        l3: "DevOps-Aufgaben zu Docker und GitLab-CI-Optimierungen"
                    }
                },
                burda: {
                    location: "München - Deutschland",
                    list: {
                        l1: "DevOps: neue Entwicklungsumgebung mit Docker und Pflege der Docker-Images",
                        l2: "Drupal-Entwickler"
                    }
                },
                limango: {
                    location: "München - Deutschland",
                    list: {
                        l1: "Senior Backend Developer: Laravel, MySql, Javascript, RabbitMq, Elasticsearch",
                        l2: "Microservice für Lieferantenbestellungen",
                        l3: "Verantwortung für Codequalität: Tests, Code Style, Dokumentation",
                        l4: "Mitglied der API-Core-Gruppe"
                    }
                },
                mothership: {
                    location: "München - Deutschland",
                    list: {
                        l1: "Backend Developer: Website-Optimierungen durch neue Erweiterungen und Module",
                        l2: "Magento Developer",
                        l3: "Exxpozed-Shop-Refactoring: Datenimport und Synchronisation von PIM nach Magento; Modul zur Verwaltung der Magento-DB in Elasticsearch; Library für Job-Scheduling in Rabbitmq; Emarsys-Integration fürs Marketing; PHP7-Fixes.",
                        l4: "Entwicklung und Pflege der Unternehmens-Core-Libraries",
                        l5: "Code Reviews"
                    },
                    linkLabel: "Exxpozed-Shop-Refactoring",
                    githubLabel: "https://github.com/mothership-gmbh"
                },
                shopwings: {
                    location: "Berlin - Deutschland",
                    list: {
                        l1: "Vagrant- und Puppet-Administrator",
                        l2: "Symfony2-Entwicklung für Webanwendung und API",
                        l3: "TDD für API – PHPUnit - Raml",
                        l4: "Senior PHP Backend Developer: Zend, Yii, PhalconPHP",
                        l5: "Frontend Developer: Javascript, Less, Css3, HTML"
                    }
                },
                mazzmediaOld: {
                    location: "Mailand - Italien"
                },
                dservice: {
                    location: "Mailand - Italien"
                },
                contactlab: {
                    location: "Mailand - Italien"
                },
                mozart: {
                    location: "Mailand - Italien"
                },
                ridesoft: {
                    location: "Mailand - Italien"
                },
                miecube: {
                    location: "Mailand - Italien"
                },
                bicocca: {
                    location: "Mailand - Italien"
                },
                bmfactory: {
                    location: "Mailand - Italien"
                },
                easytech: {
                    location: "Mailand - Italien"
                },
                marketing: {
                    location: "Mailand - Italien"
                },
                gymnasium: {
                    location: "Mailand - Italien"
                },
                sap: {
                    certId: "Zertifikats-ID: 0004057568"
                }
            }
        },
        services: {
            meta: {
                title: "Maurizio Brioschi Leistungen: Teamleiter, Softwarearchitekt, Web-Softwareentwickler, Experte für digitale Transformation",
                description: "Beauftragen Sie mich als Teamleiter, Softwarearchitekt oder Softwareentwickler und lassen Sie uns gemeinsam das volle Potenzial Ihrer Softwarelösungen auf dem Weg der digitalen Transformation entfalten",
                keywords: "teamleiter, softwarearchitekt, web-softwareentwickler, digitale transformation"
            },
            title: "Ich kann arbeiten als",
            teamLeader: {
                title: "Teamleiter",
                hero: "Ihr nächstes Level technischer Führung: Arbeiten Sie mit mir als Ihrem Teamleiter",
                intro: "Suchen Sie einen erfahrenen Profi, der Ihre technischen Projekte zum Erfolg führt? Ich biete technische Führungsleistungen, maßgeschneidert für Ihre Bedürfnisse. Als Ihr Teamleiter bringe ich jahrelange Erfahrung und eine nachweisliche Erfolgsbilanz. Das bringe ich mit:",
                sections: {
                    s1: {
                        title: "Umfassende technische Führung:",
                        body: "Ich übernehme End-to-End-Führung für Ihre technischen Projekte, von der Planung bis zur Auslieferung. Mit Blick fürs Detail und strategischem Denken sorge ich für präzise Umsetzung."
                    },
                    s2: {
                        title: "Expertenberatung und Support:",
                        body: "Ich unterstütze Ihr Team dabei, Herausforderungen zu meistern, fundierte Entscheidungen zu treffen und das volle Potenzial auszuschöpfen. Mein Hands-on-Ansatz fördert Zusammenarbeit und Exzellenz."
                    },
                    s3: {
                        title: "Maßgeschneiderte Lösungen:",
                        body: "Jedes Projekt ist einzigartig. Ich passe meinen Ansatz an Ihre Ziele und Anforderungen an – ob Prozessoptimierung, Effizienzsteigerung oder technische Hürden."
                    },
                    s4: {
                        title: "Risikominderung und Problemlösung:",
                        body: "Ich identifiziere und mindere Risiken proaktiv, damit Projekte reibungslos laufen. Mit Fokus auf Problemlösung und Contingency-Planung halte ich Ihre Projekte auf Kurs."
                    },
                    s5: {
                        title: "Kontinuierliche Verbesserung:",
                        body: "Ich glaube an kontinuierliche Verbesserung. Ich evaluiere regelmäßig die Projektleistung, sammle Feedback und implementiere Lessons Learned."
                    }
                },
                whyTitle: "Warum mich als Teamleiter wählen?",
                why: {
                    w1: "Nachgewiesene Expertise: Mit fundiertem technischen Leadership bringe ich wertvolle Fähigkeiten und Einblicke.",
                    w2: "Erfolgsorientierung: Ich liefere Ergebnisse, die Erwartungen übertreffen und langfristigen Erfolg fördern.",
                    w3: "Kollaborativer Ansatz: Ich arbeite eng mit Ihrem Team zusammen, um Vertrauen und gemeinsame Ziele zu stärken.",
                    w4: "Kundenzufriedenheit: Ihr Erfolg ist mein Ziel. Ich gehe die Extrameile für hervorragende Ergebnisse."
                },
                closingTitle: "Bereit für den nächsten Schritt?",
                closing: "Arbeiten Sie mit mir als Teamleiter und starten wir gemeinsam in eine erfolgreiche Zusammenarbeit. Kontaktieren Sie mich, um zu besprechen, wie ich Ihre Projekte unterstützen kann."
            },
            softwareArchitect: {
                title: "Softwarearchitekt",
                hero: "Entfalten Sie das Potenzial Ihrer Software: Engagieren Sie mich als Softwarearchitekt",
                intro: "Sie möchten skalierbare, wartbare und effiziente Softwarelösungen aufbauen? Als erfahrener Softwarearchitekt biete ich maßgeschneiderte Services. So kann ich helfen:",
                sections: {
                    s1: {
                        title: "Umfassende Softwarearchitektur:",
                        body: "Ich entwerfe Architekturen, die Business-Ziele und technische Anforderungen vereinen. Von Systemdesign bis Umsetzung sichere ich robuste, skalierbare und zukunftssichere Lösungen."
                    },
                    s2: {
                        title: "Technologiewahl und Bewertung:",
                        body: "Ich helfe, die richtigen Technologien und Tools auszuwählen – mit Blick auf Skalierbarkeit, Performance, Sicherheit und Kosten."
                    },
                    s3: {
                        title: "Skalierung und Performance-Optimierung:",
                        body: "Ich konzipiere Lösungen, die mit Ihrem Wachstum skalieren und hohe Lasten effizient verarbeiten."
                    },
                    s4: {
                        title: "Sicherheit und Compliance:",
                        body: "Sicherheit hat Priorität. Von Verschlüsselung bis Zugriffskontrollen setze ich robuste Maßnahmen um und stelle Compliance sicher."
                    },
                    s5: {
                        title: "Team-Zusammenarbeit und Führung:",
                        body: "Ich arbeite eng mit Ihrem Entwicklungsteam zusammen, gebe Führung und Mentoring und schaffe ein kollaboratives Umfeld."
                    },
                    s6: {
                        title: "Kontinuierliche Verbesserung und Innovation:",
                        body: "Ich halte mich über Trends und Technologien auf dem Laufenden, damit Ihre Software wettbewerbsfähig bleibt."
                    }
                },
                whyTitle: "Warum mich als Softwarearchitekt wählen?",
                why: {
                    w1: "Umfangreiche Erfahrung: Jahre an Erfahrung in Softwarearchitektur.",
                    w2: "Maßgeschneiderte Lösungen: Ansatz angepasst an Ihre Ziele.",
                    w3: "Commitment zur Exzellenz: Höchste Qualität in jeder Lösung.",
                    w4: "Kundenzufriedenheit: Enge Zusammenarbeit, um Anforderungen zu erfüllen."
                },
                closingTitle: "Bereit, Ihre Softwarelösungen zu verbessern?",
                closing: "Engagieren Sie mich als Softwarearchitekt und lassen Sie uns gemeinsam das volle Potenzial Ihrer Lösungen entfalten. Kontaktieren Sie mich für Ihre Projektanforderungen."
            },
            softwareEngineer: {
                title: "Softwareentwickler und Engineer",
                hero: "Stärken Sie Ihre Projekte mit PHP-, React.js- und Vue.js-Expertise",
                intro: "Benötigen Sie einen erfahrenen Softwareentwickler mit PHP, React.js und Vue.js? Ich biete spezialisierte Services für diese Technologien. So kann ich beitragen:",
                sections: {
                    s1: {
                        title: "Individuelle Webentwicklung:",
                        body: "Ich entwickle maßgeschneiderte Webanwendungen mit PHP, React.js und Vue.js – vom Backend bis zum responsiven Frontend."
                    },
                    s2: {
                        title: "Full-Stack-Entwicklung:",
                        body: "Ich beherrsche Frontend und Backend und kann alle Aspekte der Softwareentwicklung abdecken."
                    },
                    s3: {
                        title: "React.js- und Vue.js-Entwicklung:",
                        body: "Ich baue dynamische, responsive Benutzeroberflächen – von SPAs über PWAs bis zu UI-Komponenten."
                    },
                    s4: {
                        title: "Custom Plugins und Komponenten:",
                        body: "Ich entwickle Plugins und Komponenten für PHP-Anwendungen sowie React.js- und Vue.js-Projekte."
                    },
                    s5: {
                        title: "Qualitätssicherung und Testing:",
                        body: "Ich setze auf Qualitätssicherung mit gründlichen Tests, automatisierten Verfahren und Best Practices."
                    },
                    s6: {
                        title: "Kollaborativer Ansatz:",
                        body: "Transparente Kommunikation, regelmäßige Updates und Feedback-Integration sind für mich selbstverständlich."
                    },
                    s7: {
                        title: "Kontinuierliches Lernen:",
                        body: "Ich bleibe bei Technologien und Best Practices am Ball, um innovative Lösungen zu liefern."
                    }
                },
                whyTitle: "Warum mich als Softwareentwickler wählen?",
                why: {
                    w1: "Umfangreiche Erfahrung: Tiefe Expertise in Softwareentwicklung.",
                    w2: "Spezialisierte Skills: Fokus auf PHP, React.js und Vue.js.",
                    w3: "Maßgeschneiderte Lösungen: Passgenau auf Ihre Ziele.",
                    w4: "Zuverlässigkeit: Hohe Qualität, pünktlich und im Budget."
                },
                closingTitle: "Bereit, Ihre Projekte zu stärken?",
                closing: "Engagieren Sie mich als Softwareentwickler und lassen Sie uns Ihre Ideen mit PHP, React.js und Vue.js realisieren."
            },
            digitalTransformation: {
                title: "Experte für digitale Transformation",
                hero: "Entfalten Sie Ihr Potenzial mit digitaler Transformation und Agile-Services",
                intro: "Sind Sie bereit für digitale Transformation und Agile-Methoden, um Innovation und Wachstum zu treiben? Ich unterstütze Sie mit maßgeschneiderten Services. So kann ich helfen:",
                sections: {
                    s1: {
                        title: "Strategie für digitale Transformation:",
                        body: "Ich entwickle Strategien, die auf Ihre Geschäftsziele einzahlen – von der Analyse des Ist-Zustands bis zur Roadmap."
                    },
                    s2: {
                        title: "Agile Implementierung und Coaching:",
                        body: "Ich implementiere Scrum, Kanban und Lean und unterstütze Teams mit praxisnahem Coaching."
                    },
                    s3: {
                        title: "Digitale Innovation und Disruption:",
                        body: "Ich helfe, digitale Technologien wie Cloud, KI, Datenanalyse und IoT zu nutzen, um neue Chancen zu erschließen."
                    },
                    s4: {
                        title: "Change Management:",
                        body: "Digitale Transformation betrifft Menschen und Prozesse. Ich unterstütze bei Veränderung, Widerständen und Kulturentwicklung."
                    },
                    s5: {
                        title: "Kollaborativer Ansatz:",
                        body: "Ich arbeite eng mit Teams und Stakeholdern zusammen, um Alignment und Transparenz zu sichern."
                    },
                    s6: {
                        title: "Kontinuierliche Verbesserung:",
                        body: "Ich bleibe bei Trends und Best Practices der digitalen Transformation und Agile-Methoden aktuell."
                    }
                },
                whyTitle: "Warum mich für digitale Transformation und Agile wählen?",
                why: {
                    w1: "Expertise und Erfahrung: Nachweislicher Track Record.",
                    w2: "Maßgeschneiderte Lösungen: Passend zu Ihren Zielen.",
                    w3: "Kollaboration: Alignment und Verantwortlichkeit während der Transformation.",
                    w4: "Erfolgsorientierung: Hochwertige Ergebnisse im Zeit- und Budgetrahmen."
                },
                closingTitle: "Bereit für digitale Transformation und Agile?",
                closing: "Arbeiten Sie mit mir zusammen, um das volle Potenzial Ihrer Organisation zu entfalten."
            }
        },
        contacts: {
            meta: {
                title: "Maurizio Brioschi Kontakt: wo Sie mich finden und wie Sie in Verbindung bleiben",
                description: "Finden Sie Adresse, E-Mail, Telefon und soziale Netzwerke von Maurizio Brioschi. Kontaktieren Sie mich, um zu besprechen, wie ich Ihre Projekte unterstützen kann.",
                keywords: "email, adresse, soziale netzwerke, mobil, telefon, linkedin, github"
            },
            title: "Wie erreichen Sie mich?",
            addressLine: "Maurizio Brioschi - via Amsicora 46 - 09072 Cabras (OR) - Sardegna - Italien",
            mapTitle: "Adresse von Maurizio Brioschi"
        },
        references: {
            meta: {
                title: "Maurizio Brioschi Referenzen: was Menschen über mich sagen und Unternehmensreferenzen",
                description: "Referenzen und Geschichten über mich, was über die Jahre gut gelungen ist",
                keywords: "referenzen, karriere, jobs, unternehmen, menschen, geschichten"
            },
            title: "Meine Referenzen"
        },
        works: {
            title: "Ich habe gearbeitet und entwickelt",
            cards: {
                teatro: {
                    title: "Teatro.it",
                    description: "Das wichtigste Portal über Theater in Italien",
                    imgAlt: "Screenshot des Projekts Teatro.it",
                    bullets: {
                        b1: "Leitung eines 5-köpfigen Teams",
                        b2: "Migration und Weiterentwicklung der Plattform"
                    }
                }
            }
        },
        projects: {
            title: "Projekte"
        },
        error: {
            message: "Ein Fehler ist aufgetreten, die Seite wurde nicht gefunden."
        },
        homeBanner: {
            learnMore: "Mehr erfahren"
        }
    }
};
